import React from 'react';

import { useApolloClient } from '@apollo/react-hooks';

import { Extension } from '@atlassian/forge-ui';

import { Workspace, User } from 'src/components/types';

import { ForgeModuleType } from '../../types';
import { filterExtensions } from '../../utils/appData';
import { constructBitbucketWorkspaceAri } from '../../utils/context';
import {
  ForgeUIExtensionProviderWrapper,
  RenderForgeExtensions,
} from '../ForgeUIExtensionProviderWrapper/ForgeUIExtensionProviderWrapper';
import { ForgeUIExtensions } from '../ForgeUIExtensions/ForgeUIExtensions';

type ForgeUIExtensionsWrapperProps = {
  currentUser?: User;
  moduleType: ForgeModuleType;
  render: RenderForgeExtensions;
  workspace: Workspace;
  extensionFilter?: (extension: Extension) => boolean;
};

export const ForgeUIExtensionsWrapper = ({
  currentUser,
  moduleType,
  render,
  workspace,
  extensionFilter,
}: ForgeUIExtensionsWrapperProps): JSX.Element => {
  const enabledHostedResourcesModules = Object.values(ForgeModuleType);
  const apolloClient = useApolloClient();
  return (
    <ForgeUIExtensionProviderWrapper
      currentUser={currentUser}
      moduleType={moduleType}
      noAccessRenderFallback={render}
    >
      <ForgeUIExtensions
        contextIds={[constructBitbucketWorkspaceAri(workspace.uuid)]}
        moduleType={moduleType}
        client={apolloClient}
        render={(extensions, ...args) => {
          const filteredExtensions = filterExtensions(
            extensions,
            extensionFilter,
            true,
            enabledHostedResourcesModules
          );
          return render(filteredExtensions, ...args);
        }}
      />
    </ForgeUIExtensionProviderWrapper>
  );
};
